<template>
    <div>
        <v-dialog v-model="kpisetdialog" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on"
           >+</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline mb-4">{{$t('pmkpiinclusion.addkpiset')}}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                    <v-row>
                        <v-col v-if="!isEdit" cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('performancemanagement.kpiset')"
                                type="text"
                                ref="pmkpiitemid"
                                v-model="selections.pmkpisetid"
                                @input="updateValue"
                                dense
                                :rules="[rules.required]"
                                :items="KPISetList"
                                @change="changeKPISet(selections.pmkpisetid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col v-if="isEdit" cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('performancemanagement.kpiset')"
                                type="text"
                                ref="pmkpiitemid"
                                v-model="selections.pmkpisetdesc"
                                @input="updateValue"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.pmkpisetcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.company')"
                                type="text"
                                ref="compnyid"
                                v-model="selections.compnyid"
                                @input="updateValue"
                                dense
                                :items="companyList"
                                clearable
                                @change="changeCompany(selections.compnyid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.compnycode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.branch')"
                                type="text"
                                ref="brchid"
                                v-model="selections.brchid"
                                @input="updateValue"
                                dense
                                :items="branchList"
                                clearable
                                @change="changeBranch(selections.brchid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.brchcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.division')"
                                type="text"
                                ref="divnid"
                                v-model="selections.divnid"
                                @input="updateValue"
                                dense
                                :items="divisionList"
                                clearable
                                @change="changeDivision(selections.divnid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.divncode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.department')"
                                type="text"
                                ref="deptid"
                                v-model="selections.deptid"
                                @input="updateValue"
                                dense
                                :items="departmentList"
                                clearable
                                @change="changeDepartment(selections.deptid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.deptcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.section')"
                                type="text"
                                ref="sectioid"
                                v-model="selections.sectioid"
                                @input="updateValue"
                                dense
                                :items="sectionList"
                                clearable
                                @change="changeSection(selections.sectioid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.sectiocode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.unit')"
                                type="text"
                                ref="unitid"
                                v-model="selections.unitid"
                                @input="updateValue"
                                dense
                                :items="unitList"
                                clearable
                                @change="changeUnit(selections.unitid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.unitcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.emptype')"
                                type="text"
                                ref="emptypeid"
                                v-model="selections.emptypeid"
                                @input="updateValue"
                                dense
                                :items="empTypeList"
                                clearable
                                @change="changeEmpType(selections.emptypeid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.emptype"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.grade')"
                                type="text"
                                ref="grdid"
                                v-model="selections.grdid"
                                @input="updateValue"
                                dense
                                :items="gradeList"
                                clearable
                                @change="changeGrade(selections.grdid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.grdcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.job')"
                                type="text"
                                ref="jobid"
                                v-model="selections.jobid"
                                @input="updateValue"
                                dense
                                :items="jobList"
                                clearable
                                @change="changeJob(selections.jobid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.jobcode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="10" sm="10" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="this.$t('columns.position')"
                                type="text"
                                ref="positionid"
                                v-model="selections.positionid"
                                @input="updateValue"
                                dense
                                :items="positionList"
                                clearable
                                @change="changePosition(selections.positionid)"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="selections.poscode"
                                readonly
                                dense
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeKPISetInput">{{$t('button.cancel')}}</v-btn>
              <v-btn color="green darken-1" text @click="saveKPISetInput">{{$t('button.save')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
            :sort-by="['code']"
        >
        <template v-slot:[`item.action`]="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="modifyItemHandler(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon
                small
                class="ml-3 mr-2"
                @click="deleteItemHandler(item)"
            >
                mdi-delete
            </v-icon>
        </template>

    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>

        </v-data-table>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                positiveInteger: value => {
                    const pattern = /^[1-9]\d*$/;
                    return pattern.test(value) || this.$t('reportsparam.nonnegativeInteger');
                },
            },

            kpisetdialog: false,
            editDialog: false,
            detailItem: this.parentObject.detailItem,
         
            selections: {
                pmkpiinclusionid: this.parentObject.kpiinclusionid,
                pmkpisetid: null,
                pmkpisetcode: null,
                pmkpisetdesc: null,
                compnyid: null,
                compnycode: null,
                brchid: null,
                brchcode: null,
                divnid: null,
                divncode: null,
                deptid: null,
                deptcode: null,
                sectioid: null,
                sectiocode: null,
                unitid: null,
                unitcode: null,
                emptypeid: null,
                emptype: null,
                grdid: null,
                grdcode: null,
                jobid: null,
                jobcode: null,
                positionid: null,
                poscode: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            KPISetList: [],
            KPISetFull: [],
            companyList: [],
            companyFull: [],
            branchList: [],
            branchFull: [],
            divisionList: [],
            divisionFull: [],
            departmentList: [],
            departmentFull: [],
            sectionList: [],
            sectionFull: [],
            unitList: [],
            unitFull: [],
            empTypeList: [],
            empTypeFull: [],
            gradeList: [],
            gradeFull: [],
            jobList: [],
            jobFull: [],
            positionList: [],
            positionFull: [],

            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            errMsg: '',
            isEdit: false,
        }
    },

    methods: {
        compareArray,

        loadKPISets() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpiset/all' })
                .then((res) => {
                    const existingIds = vm.detailItem.map(item => item.pmkpisetid);
                    const filteredRec = res.data.rec.filter(item => !existingIds.includes(item.id));
                    vm.KPISetFull = filteredRec;
                    for (let i = 0; i < filteredRec.length; i++) {
                        vm.KPISetList.push({
                            text: filteredRec[i].description,
                            value: filteredRec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.response.data.message;
                });
        },

        changeKPISet(pmkpisetid) {
            const selectedSet = this.KPISetFull.find(set => set.id === pmkpisetid);
            if (selectedSet) {
                this.selections.pmkpisetcode = selectedSet.code;
            } 
        },

        loadCompanies() {
            const vm = this;
            this.$store.dispatch('get', { url: '/company/all' })
            .then((res) => {
                vm.companyFull = res.data.rec || [];
                for (let i = 0; i < vm.companyFull.length; i++) {
                        vm.companyList.push({
                            text: vm.companyFull[i].compnyname,
                            value: vm.companyFull[i].id,
                        });
                    }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        changeCompany(compnyid) {

            if (compnyid == null) {
                this.selections.compnycode = null;
                return;
            }

            const selected = this.companyFull.find(c => c.id === compnyid);
            if (selected) {
                this.selections.compnycode = selected.compnycode;
            }
        },

        loadBranches() {
            const vm = this;
            this.$store.dispatch('get', { url: '/branch/all' })
            .then((res) => {
                vm.branchFull = res.data.rec || [];
                for (let i = 0; i < vm.branchFull.length; i++) {
                    vm.branchList.push({
                        text: vm.branchFull[i].brchname,
                        value: vm.branchFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        changeBranch(brchid) {

            if (brchid == null) {
                this.selections.brchcode = null;
                return;
            }

            const selected = this.branchFull.find(b => b.id === brchid);
            if (selected) {
                this.selections.brchcode = selected.brchcode;
            }
        },

        loadDivisions() {
            const vm = this;
            this.$store.dispatch('get', { url: '/division/all' })
            .then((res) => {
                vm.divisionFull = res.data.rec || [];
                for (let i = 0; i < vm.divisionFull.length; i++) {
                    vm.divisionList.push({
                        text: vm.divisionFull[i].divnname,
                        value: vm.divisionFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        loadDepartments() {
            const vm = this;
            this.$store.dispatch('get', { url: '/department/all' })
            .then((res) => {
                vm.departmentFull = res.data.rec || [];
                for (let i = 0; i < vm.departmentFull.length; i++) {
                    vm.departmentList.push({
                        text: vm.departmentFull[i].deptname,
                        value: vm.departmentFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        loadSections() {
            const vm = this;
            this.$store.dispatch('get', { url: '/section/all' })
            .then((res) => {
                vm.sectionFull = res.data.rec || [];
                for (let i = 0; i < vm.sectionFull.length; i++) {
                    vm.sectionList.push({
                        text: vm.sectionFull[i].sectioname,
                        value: vm.sectionFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        loadUnits() {
            const vm = this;
            this.$store.dispatch('get', { url: '/unit/all' })
            .then((res) => {
                vm.unitFull = res.data.rec || [];
                for (let i = 0; i < vm.unitFull.length; i++) {
                    vm.unitList.push({
                        text: vm.unitFull[i].unitname,
                        value: vm.unitFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        loadEmpTypes() {
            const vm = this;
            this.$store.dispatch('get', { url: '/emptype/all' })
            .then((res) => {
                vm.empTypeFull = res.data.rec || [];
                for (let i = 0; i < vm.empTypeFull.length; i++) {
                    vm.empTypeList.push({
                        text: vm.empTypeFull[i].emptypedesc,
                        value: vm.empTypeFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                    vm.errMsg = err.response.data.message;
            });
        },

        loadGrades() {
            const vm = this;
            this.$store.dispatch('get', { url: '/grade/all' })
            .then((res) => {
                vm.gradeFull = res.data.rec || [];
                for (let i = 0; i < vm.gradeFull.length; i++) {
                    vm.gradeList.push({
                        text: vm.gradeFull[i].grddesc,
                        value: vm.gradeFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        loadJobs() {
            const vm = this;
            this.$store.dispatch('get', { url: '/job/all' })
            .then((res) => {
                vm.jobFull = res.data.rec || [];
                for (let i = 0; i < vm.jobFull.length; i++) {
                    vm.jobList.push({
                        text: vm.jobFull[i].jobtitle,
                        value: vm.jobFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        loadPositions() {
            const vm = this;
            this.$store.dispatch('get', { url: '/position/all' })
            .then((res) => {
                vm.positionFull = res.data.rec || [];
                for (let i = 0; i < vm.positionFull.length; i++) {
                    vm.positionList.push({
                        text: vm.positionFull[i].posdesc,
                        value: vm.positionFull[i].id,
                    });
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.response.data.message;
            });
        },

        changeDivision(divnid) {
            if (divnid == null) {
                this.selections.divncode = null;
                return;
            }
            const selected = this.divisionFull.find(d => d.id === divnid);
            if (selected) {
                this.selections.divncode = selected.divncode;
            }
        },

        changeDepartment(deptid) {
            if (deptid == null) {
                this.selections.deptcode = null;
                return;
            }
            const selected = this.departmentFull.find(d => d.id === deptid);
            if (selected) {
                this.selections.deptcode = selected.deptcode;
            }
        },

        changeSection(sectioid) {
            if (sectioid == null) {
                this.selections.sectiocode = null;
                return;
            }
            const selected = this.sectionFull.find(s => s.id === sectioid);
            if (selected) {
                this.selections.sectiocode = selected.sectiocode;
            }
        },

        changeUnit(unitid) {
            if (unitid == null) {
                this.selections.unitcode = null;
                return;
            }
            const selected = this.unitFull.find(u => u.id === unitid);
            if (selected) {
                this.selections.unitcode = selected.unitcode;
            }
        },

        changeEmpType(emptypeid) {
            if (emptypeid == null) {
                this.selections.emptype = null;
                return;
            }
            const selected = this.empTypeFull.find(e => e.id === emptypeid);
            if (selected) {
                this.selections.emptype = selected.emptype;
            }
        },

        changeGrade(grdid) {
            if (grdid == null) {
                this.selections.grdcode = null;
                return;
            }
            const selected = this.gradeFull.find(g => g.id === grdid);
            if (selected) {
                this.selections.grdcode = selected.grdcode;
            }
        },

        changeJob(jobid) {
            if (jobid == null) {
                this.selections.jobcode = null;
                return;
            }
            const selected = this.jobFull.find(j => j.id === jobid);
            if (selected) {
                this.selections.jobcode = selected.jobcode;
            }
        },

        changePosition(positionid) {
            if (positionid == null) {
                this.selections.poscode = null;
                return;
            }
            const selected = this.positionFull.find(p => p.id === positionid);
            if (selected) {
                this.selections.poscode = selected.poscode;
            }
        },
      
        modifyItemHandler(item) {
            Object.keys(item).forEach(key => {
                this.$set(this.selections, key, item[key]);
            });

            const kpiset = this.detailItem.find(i => i.pmkpisetid === item.pmkpisetid);
            if (kpiset) {
                this.selections.pmkpisetdesc = kpiset.pmkpisetdesc;
            } else {
                this.selections.pmkpisetdesc = null;
            }

            this.isEdit = true; // set editing mode
            this.kpisetdialog = true;
        },

        deleteItemHandler(item) {
            const vm = this;

            if (!confirm(this.$t('pmkpiinclusion.confirmdeletekpiinclusion'))) {
                return;
            }

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            this.$store.dispatch('delete', {url: "/kpiinclusiond/" + item.id + "/" + this.$store.getters.userId})
            .then((res) => {
            if (res.data.error) {
                vm.isErr = !vm.isErr;
                vm.errMsg = res.data.error;
                this.resetSelections();

            } else {
                let itemIndex = this.detailItem.indexOf(item);
                this.detailItem.splice(itemIndex, 1);
            }
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        saveKPISetInput() {
            const vm = this;

            if (this.isEdit) {// Update existing item

                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }
                this.$store.dispatch('put', {url: "/kpiinclusiond/" + this.selections.id, payload: this.selections})
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                    this.resetSelections();

                } else {
                    const convertedItem = {
                        ...this.selections,
                    };

                    // Update the existing item in detailItem
                    const index = this.detailItem.findIndex(item => item.id === this.selections.id);
                    if (index !== -1) {
                        this.$set(this.detailItem, index, convertedItem);
                    }

                    this.kpisetdialog = false;
                    this.resetSelections();
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });

            } else {// Create new item
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }
                this.$store.dispatch('post', {url: "/kpiinclusiond/create", payload: this.selections})
                .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                    this.resetSelections();

                } else {
                    const convertedItem = {
                        ...this.selections,
                        id: res.data.id,
                    };

                    this.detailItem.push(convertedItem);

                    this.kpisetdialog = false;
                    this.resetSelections();
                }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                });
            }
            
        },

        updateValue() {
            this.$emit('input', {
                pmkpiinclusionid: this.parentObject.kpiinclusionid,
                pmkpisetid: this.selections[0].pmkpiitemid,
                pmkpisetcode: this.selections[0].pmkpisetcode,
                pmkpisetdesc: this.selections[0].pmkpisetdesc,
                compnyid: this.selections[0].compnyid,
                compnycode: this.selections[0].compnycode,
                brchid: this.selections[0].brchid,
                brchcode: this.selections[0].brchcode,
                divnid: this.selections[0].divnid,
                divncode: this.selections[0].divncode,
                deptid: this.selections[0].deptid,
                deptcode: this.selections[0].deptcode,
                sectioid: this.selections[0].sectioid,
                sectiocode: this.selections[0].sectiocode,
                unitid: this.selections[0].unitid,
                unitcode: this.selections[0].unitcode,
                emptypeid: this.selections[0].emptypeid,
                emptype: this.selections[0].emptype,
                grdid: this.selections[0].grdid,
                grdcode: this.selections[0].grdcode,
                jobid: this.selections[0].jobid,
                jobcode: this.selections[0].jobcode,
                positionid: this.selections[0].positionid,
                poscode: this.selections[0].poscode,
                stamp: 0, // reset stamp to 0
                userid: this.$store.getters.userId
            });
        },

        closeKPISetInput() {
            this.kpisetdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;
            this.isEdit = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.selections = {
                pmkpiinclusionid: this.parentObject.kpiinclusionid,
                pmkpisetid: null,
                pmkpisetcode: null,
                pmkpisetdesc: null,
                compnyid: null,
                compnycode: null,
                brchid: null,
                brchcode: null,
                divnid: null,
                divncode: null,
                deptid: null,
                deptcode: null,
                sectioid: null,
                sectiocode: null,
                unitid: null,
                unitcode: null,
                emptypeid: null,
                emptype: null,
                grdid: null,
                grdcode: null,
                jobid: null,
                jobcode: null,
                positionid: null,
                poscode: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },          
    },

    mounted() {
        this.loadKPISets();
        this.loadCompanies();
        this.loadBranches();
        this.loadDivisions();
        this.loadDepartments();
        this.loadSections();
        this.loadUnits();
        this.loadEmpTypes();
        this.loadGrades();
        this.loadJobs();
        this.loadPositions();
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>